const form = document.getElementById('show_results_form');
const dropdown = document.getElementById('show_results_type');
dropdown?.addEventListener('change', () => {
    form?.submit();
});
